export const joinArrayString = (
  arr: string[],
  separator: string = ','
): string => arr.join(separator)
